import { defineMessages } from 'react-intl'

export const subscriptionHistoryMessages = defineMessages({
  mobileTableHeader: {
    id: 'subscriptionTableHistory.mobileTableHeader',
    description: 'Subscription mobile table header',
    defaultMessage: 'Subscription History',
  },
  dateHeader: {
    id: 'subscriptionTableHistory.dateHeader',
    description: 'Subscription history data table header',
    defaultMessage: 'Date',
  },
  planHeader: {
    id: 'subscriptionTableHistory.planHeader',
    description: 'Subscription history plan table header',
    defaultMessage: 'Event',
  },
  renewalExpirationDate: {
    id: 'subscriptionTableHistory.renewalExpirationDate',
    description: 'Renewal/Expiration Date of subscription history table header',
    defaultMessage: 'Renewal/Expire Date',
  },
  dateActivateLabel: {
    id: 'subscriptionTableHistory.dateActivateLabel',
    description: 'Data activate of subscription history table header',
    defaultMessage: 'Date Activated',
  },
  paymentInfoLabel: {
    id: 'subscriptionTableHistory.paymentInfoLabel',
    description: 'Payment info of subscription history table header',
    defaultMessage: 'Payment method',
  },
  noHistoryTitle: {
    id: 'subscriptionTableHistory.noHistoryTitle',
    description: 'Title for message block when no subscription history',
    defaultMessage: 'No subscription history yet',
  },
  noHistoryDesc: {
    id: 'subscriptionTableHistory.noHistoryDesc',
    description:
      'Description under title for message block when no subscription history',
    defaultMessage:
      'Only subscriptions purchased through Savant Central Management will show history',
  },
})
